import React, { useContext, useEffect, useRef, useState } from "react";
import "../../../../styles/workspace_styles/CustomerAdministratorStyles/Customers/Customers.css";
import {thingsBoardMicroserviceUrl} from "../../../../microservices/thingsboard_microservice.js";
import { LoadShortDate } from "../../../../functions/LoadShortDate.js";
import { LoadShortTime } from "../../../../functions/LoadShortTime.js";
import { AppContext } from "../../../AppProvider.jsx";
import NavigationBar from "../../../navigation_components/NavigationBar.jsx";
import CustomerAdministratorSideBar from "../../../sidebar_components/CustomerAdministratorSideBar.jsx";
import { useNavigate } from "react-router-dom";
function CustomerUsersTable({customers}){
    const[selectedCustomer,setSelectedCustomer] = useState();
    const[customersSortType,setCustomersSortType] = useState('title-ascending');
    if(!Array.isArray(customers) || customers.length === 0) return null;
    return(
        <div className="customer-administrator-customers-table-container">
            <table className="customer-administrator-customers-table">
                <thead>
                    <tr id="customer-administrator-customers-table-header-row">
                        <th onClick={() =>{
                            if(customersSortType === 'title-ascending') setCustomersSortType('title-descending');
                            else setCustomersSortType('title-ascending');
                        }}>Title</th>
                        <th>Date created</th>
                        <th>Time created</th>
                        <th>Email address</th>
                        <th onClick={() =>{
                            if(customersSortType === 'country-ascending') setCustomersSortType('country-descending');
                            else setCustomersSortType('country-ascending');
                        }}>Country</th>
                        <th onClick={() =>{
                            if(customersSortType === 'city-ascending') setCustomersSortType('city-descending');
                            else setCustomersSortType('city-ascending');
                        }}>City</th>
                    </tr>
                </thead>
                <tbody>
                    {[...customers].filter(customer => customer?.external?.title !== 'Public').sort((a,b) =>{
                        if(customersSortType === 'title-ascending') return a?.external?.title?.localeCompare(b?.external?.title);
                        else if(customersSortType === 'title-descending') return b?.external?.title?.localeCompare(a?.external?.title);
                        if(customersSortType === 'country-ascending') return a?.external?.country?.localeCompare(b?.external?.country);
                        else if(customersSortType === 'country-descending') return b?.external?.country?.localeCompare(a?.external?.country);
                        if(customersSortType === 'city-ascending') return a?.external?.city?.localeCompare(b?.external?.city);
                        else if(customersSortType === 'city-descending') return b?.external?.city?.localeCompare(a?.external?.city);
                        else return 0;
                    }).map(customer =>{
                        return (
                            <tr key={customer.external.id} onClick={() =>{setSelectedCustomer(customer)}}>
                                <td>{customer?.external?.title}</td>
                                <td>{LoadShortDate(customer.external.createdTime)}</td>
                                <td>{LoadShortTime(customer.external.createdTime)}</td>
                                <td>{customer.external.email}</td>
                                <td><div>{customer.external.country}</div></td>
                                <td><div>{customer.external.city}</div></td>
                            </tr>
                        );
                    })}
                </tbody>
            </table>
        </div>
    );
};
const Customers = () =>{
    const {user,customerIotProfile,logout} = useContext(AppContext);
    const [customers,setCustomers] = useState([]);
    const [customersFetched,setCustomersFetched] = useState(false);
    const logoutTimerRef = useRef(null);
    const navigate = useNavigate();
    const fetchCustomerUsers= async() =>{
        try{
            const url = `${thingsBoardMicroserviceUrl}/customers/users/admin/${customerIotProfile?.id}/customers`;
            const response = await fetch(url,{
                method:'GET',
                headers:{
                    'Authorization':`Bearer ${user.access_token}`,
                    'Content-Type':'application/json'
                }
            });
            if(response.ok){
                const responseData = await response.json();
                setCustomers(responseData);
            }
            if(Number(response.status) === 401) logout();
        }
        catch(error){
            console.error(error);
        }
    };
    useEffect(() =>{
        if(!user){
            logoutTimerRef.current = setTimeout(() =>{
                navigate('/');
                window.location.reload();
            },10);
            return;
        }
        else{
            if(logoutTimerRef.current){
                clearTimeout(logoutTimerRef.current);
                logoutTimerRef.current = null;
            }
        }
        if(!customersFetched){
            fetchCustomerUsers();
            setCustomersFetched(true);
        }
    },[customersFetched]);
    return(
        <div className="customer-administrator-customers-page">
            <NavigationBar/>
            <div className="customer-administrator-customers-page-layout">
                <div>
                    <CustomerAdministratorSideBar/>
                </div>
                <div className="customer-administrator-customers-parent-container">
                    <div className="customer-administrator-customers-container">
                        <div className="customer-administrator-customers-header-container">
                            <h2>Customers</h2>
                            <div className="customer-administrator-customers-header-controls">
                                <button className="customer-administrator-refresh-customers-button" onClick={() =>{}}>
                                    <img src={`${process.env.PUBLIC_URL}/images/refresh-icon.png`} alt="Refresh"/>
                                </button>
                            </div>
                        </div>
                        {<CustomerUsersTable
                            customers={customers}
                            access_token={user?.access_token}
                        />}
                    </div>
                </div>
            </div>
        </div>
    );
};
export default Customers;